module.exports = __webpack_public_path__ + "img/clitoris_on.6f61e798.gif";